import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { LatestStatusResponse } from '@core/models';
import { StatusService } from '@core/services/status.service';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, catchError, of } from 'rxjs';
import { DeviceAlarmsTabComponent } from '../../../devices/components/device-alarms-tab/device-alarms-tab.component';
import { FedDevice, deviceSelection } from '../../fed-devices';
import { InstallationDeviceSelectComponent } from '../installation-device-select/installation-device-select.component';

// Alarms belong to devices, so the tab shows those of a device that feeds the installation, as
// that device's own Alarms tab shows them.
@Component({
  selector: 'xemex-installation-alarms-tab',
  imports: [DeviceAlarmsTabComponent, InstallationDeviceSelectComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './installation-alarms-tab.component.html',
})
export class InstallationAlarmsTabComponent {
  readonly installationOid = input.required<string>();
  readonly devices = input<FedDevice[]>([]);

  private readonly statusService = inject(StatusService);

  readonly selectedDeviceId = deviceSelection(this.devices);

  // The device page shows no alarms for a device whose latest status cannot be read, and so does
  // this tab.
  readonly statusRead = rxResource({
    params: () => this.selectedDeviceId() ?? undefined,
    stream: ({ params: deviceId }) => this.readLatestStatus(deviceId),
  });

  readonly latestStatus = computed(() => this.statusRead.value());

  private readLatestStatus(deviceId: number): Observable<LatestStatusResponse | undefined> {
    return this.statusService
      .getLatestStatus(String(deviceId))
      .pipe(catchError(() => of(undefined)));
  }
}
